import React, { useState } from 'react';
import { Search, SlidersHorizontal, X } from 'lucide-react';
import Header from './components/Header4';
import Footer from './components/Footer4';
import ProductCard from './components/ProductCard';
import Button from './components/Button';

const Shop = () => {
    const [selectedCategory, setSelectedCategory] = useState('all');
    const [sortBy, setSortBy] = useState('featured');
    const [showFilters, setShowFilters] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');

    const categories = ['All', 'Silk Sarees', 'Lehengas', 'Kurtas', 'Dupattas', 'Bridal Wear', 'Handloom'];
    const sortOptions = [
        { value: 'featured', label: 'Featured' },
        { value: 'price-low', label: 'Price: Low to High' },
        { value: 'price-high', label: 'Price: High to Low' },
        { value: 'newest', label: 'Newest' },
    ];

    const products = [
        { id: 1, name: 'Banarasi Silk Saree', category: 'Silk Sarees', price: 12999, image: 'https://images.pexels.com/photos/2955819/pexels-photo-2955819.jpeg?auto=compress&cs=tinysrgb&w=400', tag: 'NEW' },
        { id: 2, name: 'Designer Lehenga Set', category: 'Lehengas', price: 24500, originalPrice: 29999, image: 'https://images.pexels.com/photos/1536619/pexels-photo-1536619.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 3, name: 'Cotton Kurta Collection', category: 'Kurtas', price: 3499, tag: 'NEW', image: 'https://images.pexels.com/photos/3014853/pexels-photo-3014853.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 4, name: 'Chanderi Silk Dupatta', category: 'Dupattas', price: 4999, image: 'https://images.pexels.com/photos/4614070/pexels-photo-4614070.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 5, name: 'Embroidered Anarkali', category: 'Lehengas', price: 8999, originalPrice: 11999, image: 'https://images.pexels.com/photos/6712360/pexels-photo-6712360.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 6, name: 'Tussar Silk Saree', category: 'Silk Sarees', price: 15999, tag: 'NEW', image: 'https://images.pexels.com/photos/7275385/pexels-photo-7275385.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 7, name: 'Bridal Lehenga', category: 'Bridal Wear', price: 45000, image: 'https://images.pexels.com/photos/8953474/pexels-photo-8953474.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 8, name: 'Zardozi Work Kurta', category: 'Kurtas', price: 6499, originalPrice: 8999, image: 'https://images.pexels.com/photos/2955375/pexels-photo-2955375.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 9, name: 'Kanjivaram Silk Saree', category: 'Silk Sarees', price: 18999, image: 'https://images.pexels.com/photos/2681751/pexels-photo-2681751.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 10, name: 'Handloom Cotton Saree', category: 'Handloom', price: 5999, image: 'https://images.pexels.com/photos/2916387/pexels-photo-2916387.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 11, name: 'Bridal Dupatta Set', category: 'Bridal Wear', price: 12500, originalPrice: 15999, image: 'https://images.pexels.com/photos/3224610/pexels-photo-3224610.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 12, name: 'Ikat Print Kurta', category: 'Handloom', price: 4299, image: 'https://images.pexels.com/photos/2220316/pexels-photo-2220316.jpeg?auto=compress&cs=tinysrgb&w=400' },
    ];

    const filteredProducts = products.filter((product) => {
        const matchesCategory = selectedCategory === 'all' || product.category === selectedCategory;
        const matchesSearch = product.name.toLowerCase().includes(searchQuery.toLowerCase());
        return matchesCategory && matchesSearch;
    });

    return (
        <div className="w-full min-h-screen bg-white" style={{ fontFamily: "'Work Sans', sans-serif" }}>
            <Header />
            <link href="https://fonts.googleapis.com/css2?family=Work+Sans:wght@300;400;500;600;700&display=swap" rel="stylesheet" />

            <main className="pt-20 md:pt-24">
                {/* Hero Banner */}
                <div className="bg-[#F0F7FA] py-10 md:py-16 px-4 sm:px-6 text-center">
                    <p className="text-xs tracking-[0.2em] uppercase mb-2 text-[#62B6CB] font-medium">Curated for you</p>
                    <h1 className="text-3xl md:text-4xl lg:text-5xl font-semibold text-[#1B4965] mb-3">Our Collection</h1>
                    <p className="text-sm md:text-base text-[#6B7280] max-w-xl mx-auto font-light">
                        Discover handcrafted Indian fashion pieces that celebrate heritage and modern elegance
                    </p>
                </div>

                {/* Filters & Sort Bar */}
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                        {/* Search */}
                        <div className="relative flex-1 max-w-md">
                            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#6B7280]" />
                            <input
                                type="text"
                                placeholder="Search products..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                className="w-full pl-10 pr-4 py-2.5 text-sm border border-[#E5E7EB] rounded-sm focus:outline-none focus:border-[#1B4965] text-[#1A1A1A]"
                            />
                        </div>

                        <div className="flex items-center gap-3">
                            {/* Mobile Filter Toggle */}
                            <button
                                className="md:hidden flex items-center gap-2 px-4 py-2.5 text-sm border border-[#E5E7EB] rounded-sm text-[#1A1A1A]"
                                onClick={() => setShowFilters(!showFilters)}
                            >
                                <SlidersHorizontal className="w-4 h-4" />
                                Filters
                            </button>

                            {/* Sort */}
                            <select
                                value={sortBy}
                                onChange={(e) => setSortBy(e.target.value)}
                                className="px-4 py-2.5 text-sm border border-[#E5E7EB] rounded-sm focus:outline-none focus:border-[#1B4965] text-[#1A1A1A] bg-white"
                            >
                                {sortOptions.map((option) => (
                                    <option key={option.value} value={option.value}>{option.label}</option>
                                ))}
                            </select>
                        </div>
                    </div>

                    {/* Category Tabs */}
                    <div className={`mt-4 flex flex-wrap gap-2 ${showFilters ? 'block' : 'hidden md:flex'}`}>
                        {categories.map((cat) => (
                            <button
                                key={cat}
                                onClick={() => setSelectedCategory(cat === 'All' ? 'all' : cat)}
                                className={`px-4 py-2 text-xs font-medium tracking-wider uppercase rounded-sm transition-all duration-300 ${
                                    (cat === 'All' && selectedCategory === 'all') || cat === selectedCategory
                                        ? 'bg-[#1B4965] text-white'
                                        : 'bg-[#F0F7FA] text-[#1B4965] hover:bg-[#1B4965]/10'
                                }`}
                            >
                                {cat}
                            </button>
                        ))}
                    </div>
                </div>

                {/* Products Grid */}
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16">
                    <p className="text-sm text-[#6B7280] mb-6">{filteredProducts.length} products</p>

                    {filteredProducts.length > 0 ? (
                        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4 lg:gap-6">
                            {filteredProducts.map((product) => (
                                <ProductCard key={product.id} product={product} />
                            ))}
                        </div>
                    ) : (
                        <div className="text-center py-20">
                            <p className="text-lg text-[#6B7280] mb-4">No products found</p>
                            <Button variant="secondary" onClick={() => { setSelectedCategory('all'); setSearchQuery(''); }}>
                                Clear Filters
                            </Button>
                        </div>
                    )}
                </div>
            </main>

            <Footer />
        </div>
    );
};

export default Shop;
